export default __webpack_public_path__ + "static/media/R1000.f033c424.png";